import { http } from 'lib/msal';
import getEnvironment from 'lib/env';

let api = {
	// signal — optional AbortController signal. Pass controller.signal from the
	// calling action or hook to cancel the request when the component unmounts.
	get: function (route, useBigAzure, signal) {
		if (useBigAzure) {
			return http.get(route, { baseURL: getEnvironment()?.baseURL, signal });
		}
		return http.get(route, { signal });
	},
	put: function (route, data, signal) {
		return http.put(route, data, {
			headers: {
				'content-type': 'application/json'
			},
			signal,
		});
	},
	post: function (route, data, signal) {
		return http.post(route, data, {
			headers: {
				'content-type': 'application/json'
			},
			signal,
		});
	},
	delete: function (route, data, signal) {
		return http.delete(route, {
			data: data != null ? data : null,
			signal,
		});
	},
	patch: function (route, operations, signal) {
		return http.patch(route, operations, { signal });
	},
	getFile: function (id) {
		return http.get(`fileItems/${id}`, {
			responseType: 'blob',
		});
	},
	getOneDriveFile: function (route, token) {
		return http.get(route, {
			headers: {
				'Authorization': `Bearer ${token}`
			}
		});
	},
	postFile: function (route, file, signal) {
		const formData = new FormData();
		formData.append('file', file);

		// axios v1 detects FormData automatically and lets the browser set
		// Content-Type with the correct multipart boundary. Never set it manually —
		// doing so omits the boundary and breaks file parsing on the server.
		return http.post(route, formData, { signal });
	},
};

export default api;